/**
 * AI Settings - i18n registration
 */

import { addLocaleMessages } from '@/i18n';
import enUS from './locales/en-US';
import zhCN from './locales/zh-CN';
import zhTW from './locales/zh-TW';
import jaJP from './locales/ja-JP';

// 注册 AI Settings 相关的多语言
addLocaleMessages('en', enUS);
addLocaleMessages('cn', zhCN);
addLocaleMessages('tw', zhTW);
addLocaleMessages('jp', jaJP);

